import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { formatToDollars } from "@/utils/etc";
import { useT } from "@transifex/react";
import type { TransactionDetails } from "ipctg-inflow-types/InFlowDB";

export const CartTransactionDetails: React.FC<{ transactionDetails: TransactionDetails; isUserEnteredPromoApplied: boolean }> = (props) => {
  const t = useT();
  const { transactionDetails, isUserEnteredPromoApplied } = props;
  const makeRow = (title: string, value: number, color = "text-typography-900", signal = "") => (
    <HStack className="justify-between">
      <Text className={`font-[600] leading-[22px] text-[16px] ${color}`}>{title}:</Text>
      <Text className={`font-[600] leading-[22px] text-[16px] ${color} min-w-[70px] text-right`}>
        {signal}
        {formatToDollars(value, false, true)}
      </Text>
    </HStack>
  );

  return (
    <VStack className="gap-[12px]">
      {makeRow(transactionDetails.rateName, transactionDetails.baseRate)}
      {(transactionDetails.computedDiscount ?? 0) > 0 &&
        makeRow(
          !isUserEnteredPromoApplied && transactionDetails.promoCodeRedeemCopy
            ? `${t("Promotion")} (${transactionDetails.promoCodeRedeemCopy})`
            : t("Discount"),
          transactionDetails.computedDiscount ?? 0,
          "text-success-700",
          "-",
        )}
      {transactionDetails.convenienceFee > 0 && makeRow(t("Service Fee"), transactionDetails.convenienceFee)}
      {transactionDetails.tax > 0 && makeRow(t("Taxes"), transactionDetails.tax)}
    </VStack>
  );
};
